import dayjs, { unix } from 'dayjs'

import { useLocalization } from '@/shared/composables/localization'

export type GalleryDateGroup<T> = {
  key: string
  label: string
  items: T[]
}

export const getGalleryDateGroupKey = (timestamp: number) => {
  return unix(timestamp).tz().format('YYYY-MM-DD')
}

export const getGalleryDateGroupLabel = (timestamp: number) => {
  const dEvent = unix(timestamp).tz()
  const now = dayjs().tz()
  const { t } = useLocalization()

  if (dEvent.isToday()) {
    return t('common.today')
  }
  if (dEvent.isYesterday()) {
    return t('common.yesterday')
  }
  if (dEvent.isSame(now, 'week')) {
    return dEvent.format('dddd')
  }
  if (dEvent.isSame(now, 'year')) {
    return dEvent.format('DD MMMM')
  }
  return dEvent.format(`DD MMMM YYYY ${t('common.y')}`)
}

export const groupGalleryItemsByDate = <T extends { timestamp: number }> (
  items: T[],
): GalleryDateGroup<T>[] => {
  const groups = new Map<string, GalleryDateGroup<T>>()

  items.forEach((item) => {
    const key = getGalleryDateGroupKey(item.timestamp)
    const existing = groups.get(key)
    if (existing) {
      existing.items.push(item)
      return
    }

    groups.set(key, {
      key,
      label: getGalleryDateGroupLabel(item.timestamp),
      items: [item],
    })
  })

  return Array.from(groups.values())
}
